// Decide which "side" is viewing an order list, to count unread messages from
// the *other* side. A filter (clientId/prosthetistId) wins when present; this
// is what scopes admin views. Otherwise fall back to the authenticated user's
// type — this is what makes the unread badge work on the client dashboard,
// which calls useOrders() without filters.
//
// Admins with no filter resolve to null (no badge), preserving prior behaviour:
// 'admin' is not a valid sender_type, so it must not be passed as the viewer.
function resolveUserType(filters, authUserType) {
    const f = filters || {};
    if (f.clientId) return 'client';
    if (f.prosthetistId) return 'prosthetist';
    if (authUserType === 'client') return 'client';
    if (authUserType === 'prosthetist') return 'prosthetist';
    return null;
}

module.exports = { resolveUserType };
